import { apiClient } from './api';
import { ENDPOINTS } from './endpoints';

interface UpdateActionTrackerPayload {
  action_type: 'onboarding' | 'consent';
  current_step_id?: string;
  completed_steps?: string[];
  status?: 'completed' | 'skipped' | 'pending' | 'in_progress';
  metadata?: any;
  consent_type?: string[];
  version?: string;
}

export const updateActionTracker = async (payload: UpdateActionTrackerPayload) => {
  try {
    const response = await apiClient.post(ENDPOINTS.USER_ACTIONS, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating action tracker:', error);
    throw error;
  }
};

export const getActionChecklist = async () => {
  try {
    const response = await apiClient.get(ENDPOINTS.USER_ACTIONS);
    return response.data.checklist;
  } catch (error) {
    console.error('Error getting action checklist:', error);
    throw error;
  }
};

export const getAllCoughRefids = async (
  profile_id: string | number,
  startDate: string,
  endDate: string,
  timeZone: string
) => {
  try {
    const response = await apiClient.post( "/api/user/getAllCoughRefIds",
      {profile_id,startDate,endDate,timeZone});
    return response;
  } catch (error) {
    console.error('Error getting cough refids:', error);
    throw error;
  }
};

export const getAllClearRefids = async (
  profile_id: string | number,
  startDate: string,
  endDate: string,
  timeZone: string
) => {
  try {
    const response = await apiClient.post( "/api/user/getAllClearRefIds",
      {profile_id,startDate,endDate,timeZone});
    return response;
  } catch (error) {
    console.error('Error getting clear refids:', error);
    throw error;
  }
};
